import PropTypes from 'prop-types'
import cn from '../modules/cn'
import Skeleton from './Skeleton'
import WithAddon from './WithAddon'
import Clickable from './Clickable'

function Breadcrumb({
  to, href, onClick, children, addonProps,
}) {
  return (
    <span className="pt-1">
      <WithAddon
        className="group p-0"
        leadingAddon={<span className="text-base text-gray-200 group-hover:text-gray-400 mr-1">/</span>}
      /* eslint-disable-next-line react/jsx-props-no-spreading */
        {...addonProps}
      >
        <Clickable
          to={to}
          href={href}
          onClick={onClick}
          className={cn(
            'text-xs font-bold uppercase text-gray-400 hover:text-gray-800',
            (!to && !onClick) && 'pointer-events-none',
          )}
        >
          {children || <Skeleton sm className="m-0 w-24" />}
        </Clickable>
      </WithAddon>
    </span>
  )
}

Breadcrumb.propTypes = {
  children: PropTypes.string,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string,
  })]),
  onClick: PropTypes.func,
  href: PropTypes.string,
  addonProps: PropTypes.shape(WithAddon.PropTypes),
}

Breadcrumb.defaultProps = {
  children: null,
  to: null,
  onClick: null,
  href: null,
  addonProps: null,
}

export default Breadcrumb
